// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const SystemRolesSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '196'}
        height={props.height ? props.height.toString() : '120'}
        viewBox='0 0 196 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <circle
            cx='20.5'
            cy='35'
            r='2'
            transform='rotate(-90 20.5 35)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='20.5'
            cy='29'
            r='2'
            transform='rotate(-90 20.5 29)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='20.5005'
            cy='23'
            r='2'
            transform='rotate(-90 20.5005 23)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M20.5 39.5V79.5H43M45 79.5H49M51 79.5H53'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M29.5 79.5H177.5V108.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.24'
            strokeLinecap='round'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(1 0 0 -1 175 112)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            d='M62.1304 22H129.87L134 115H58L62.1304 22Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            width='92'
            height='5'
            transform='matrix(1 0 0 -1 50 120)'
            fill='var(--center-channel-color)'
            fillOpacity='0.4'
        />
        <rect
            x='30'
            y='16'
            width='131'
            height='86'
            rx='4'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='4'
        />
        <rect
            x='34'
            y='20'
            width='46'
            height='78'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M49.8109 27.0273L66.5002 27.0273'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M49.8109 29.6628L59.4732 29.6628'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M38.392 38.4453H51.5678'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='41.5092'
            cy='27.5105'
            r='4.34771'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='39.4795'
            cy='43.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 43.1602H70.0137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='39.4795'
            cy='50.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 50.1602H64.7434'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='39.4795'
            cy='58.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 58.1602H72.6489'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='39.4795'
            cy='65.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 65.1602H70.0137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='39.4795'
            cy='72.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 72.1602H64.7434'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='39.4795'
            cy='79.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M45.4189 79.1602H72.6489'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M150 108.5H122.5'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M119 108.5H113'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M110 108.5H104'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <ellipse
            cx='138.058'
            cy='43.6274'
            rx='14.1972'
            ry='13.767'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <mask
            id='mask0_4441_155706'
            mask-type='luminance'
            maskUnits='userSpaceOnUse'
            x='124'
            y='30'
            width='28'
            height='28'
        >
            <path
                d='M124.288 43.8848C124.288 51.5124 130.49 57.6952 138.139 57.6952C142.476 57.6952 146.348 55.7078 148.887 52.5958C150.827 50.2191 151.99 47.1876 151.99 43.8848C151.99 36.2573 145.788 30.0745 138.139 30.0745C130.49 30.0745 124.288 36.2573 124.288 43.8848Z'
                fill='white'
            />
        </mask>
        <g mask='url(#mask0_4441_155706)'>
            <path
                d='M129.452 51.4217C130.886 50.4043 135.904 49.4434 138.234 49.0901C140.384 49.514 145.295 50.6586 147.732 51.8456C150.169 53.0326 150.539 56.7208 150.42 58.4165H126.047C126.047 53.7533 127.66 52.6935 129.452 51.4217Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M129.452 51.4217C130.886 50.4043 135.904 49.4434 138.234 49.0901C140.384 49.514 145.295 50.6586 147.732 51.8456C150.169 53.0326 150.539 56.7208 150.42 58.4165H126.047C126.047 53.7533 127.66 52.6935 129.452 51.4217Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.8'
            />
            <path
                d='M141.472 49.8071L140.46 46.5787H136.016L135.195 49.8071C136.988 50.7038 139.678 50.7038 141.472 49.8071Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M141.472 49.8071L140.46 46.5787H136.016L135.195 49.8071C136.988 50.7038 139.678 50.7038 141.472 49.8071Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M144.176 40.5879C144.767 40.4301 144.794 41.2999 144.57 42.2022C144.365 43.0245 144.176 44.3681 143.56 44.042C142.819 45.9781 141.466 47.4502 139.831 48.0331C139.323 48.2524 138.783 48.3723 138.223 48.3723C137.503 48.3723 136.815 48.1735 136.186 47.8199C134.773 47.1323 133.617 45.7633 132.955 44.0211C132.348 44.1712 132.09 42.7509 131.953 42.2022C131.78 41.5052 131.559 40.5878 132.348 40.5878C132.364 36.3648 135.005 32.9478 138.262 32.9478C141.518 32.9478 144.16 36.3648 144.176 40.5879Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M144.176 40.5879C144.767 40.4301 144.794 41.2999 144.57 42.2022C144.365 43.0245 144.176 44.3681 143.56 44.042C142.819 45.9781 141.466 47.4502 139.831 48.0331C139.323 48.2524 138.783 48.3723 138.223 48.3723C137.503 48.3723 136.815 48.1735 136.186 47.8199C134.773 47.1323 133.617 45.7633 132.955 44.0211C132.348 44.1712 132.09 42.7509 131.953 42.2022C131.78 41.5052 131.559 40.5878 132.348 40.5878C132.364 36.3648 135.005 32.9478 138.262 32.9478C141.518 32.9478 144.16 36.3648 144.176 40.5879Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M133.213 34.161C133.989 33.0897 134.545 32.9069 134.817 32.8175C134.909 32.7873 134.968 32.7678 134.993 32.7283C136.062 31.0266 140.638 31.3426 141.868 32.2707C144.668 34.3823 143.978 35.8397 144.295 37.5774C144.459 38.4688 144.147 39.5627 144.075 40.4804C143.986 39.8716 143.483 37.996 143.445 37.7901C143.001 36.7139 141.057 38.0233 140.037 37.9694C137.746 37.8484 136.031 37.4462 134.817 35.9965C134.454 37.2821 133.339 38.8431 132.647 38.9895L132.5 40.2913C132.084 37.9813 131.754 36.1724 133.213 34.161Z'
                fill='var(--neutral-1200)'
            />
        </g>
        <ellipse
            cx='101.058'
            cy='80.6274'
            rx='14.1972'
            ry='13.767'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <mask
            id='mask1_4441_155706'
            maskUnits='userSpaceOnUse'
            x='87'
            y='67'
            width='28'
            height='28'
            mask-type='luminance'
        >
            <path
                d='M87.2884 80.8848C87.2884 88.5124 93.4899 94.6952 101.139 94.6952C105.476 94.6952 109.348 92.7078 111.887 89.5958C113.827 87.2191 114.99 84.1876 114.99 80.8848C114.99 73.2573 108.788 67.0745 101.139 67.0745C93.4899 67.0745 87.2884 73.2573 87.2884 80.8848Z'
                fill='white'
            />
        </mask>
        <g mask='url(#mask1_4441_155706)'>
            <path
                d='M92.4524 88.4217C93.8861 87.4043 98.904 86.4434 101.234 86.0901C103.384 86.514 108.295 87.6586 110.732 88.8456C113.169 90.0326 113.539 93.7208 113.42 95.4165H89.0474C89.0474 90.7533 90.6603 89.6935 92.4524 88.4217Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M92.4524 88.4217C93.8861 87.4043 98.904 86.4434 101.234 86.0901C103.384 86.514 108.295 87.6586 110.732 88.8456C113.169 90.0326 113.539 93.7208 113.42 95.4165H89.0474C89.0474 90.7533 90.6603 89.6935 92.4524 88.4217Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.8'
            />
            <path
                d='M104.472 86.8071L103.46 83.5787H99.0163L98.1945 86.8071C99.9881 87.7038 102.678 87.7038 104.472 86.8071Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M104.472 86.8071L103.46 83.5787H99.0163L98.1945 86.8071C99.9881 87.7038 102.678 87.7038 104.472 86.8071Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M107.176 77.5879C107.767 77.4301 107.794 78.2999 107.57 79.2022C107.365 80.0245 107.176 81.3681 106.56 81.042C105.819 82.9781 104.466 84.4502 102.831 85.0331C102.323 85.2524 101.783 85.3723 101.223 85.3723C100.503 85.3723 99.8151 85.1735 99.186 84.8199C97.7734 84.1323 96.6173 82.7633 95.9551 81.0211C95.3476 81.1712 95.0899 79.7509 94.9532 79.2022C94.7796 78.5052 94.5589 77.5878 95.3476 77.5878C95.3638 73.3648 98.0055 69.9478 101.262 69.9478C104.518 69.9478 107.16 73.3648 107.176 77.5879Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M107.176 77.5879C107.767 77.4301 107.794 78.2999 107.57 79.2022C107.365 80.0245 107.176 81.3681 106.56 81.042C105.819 82.9781 104.466 84.4502 102.831 85.0331C102.323 85.2524 101.783 85.3723 101.223 85.3723C100.503 85.3723 99.8151 85.1735 99.186 84.8199C97.7734 84.1323 96.6173 82.7633 95.9551 81.0211C95.3476 81.1712 95.0899 79.7509 94.9532 79.2022C94.7796 78.5052 94.5589 77.5878 95.3476 77.5878C95.3638 73.3648 98.0055 69.9478 101.262 69.9478C104.518 69.9478 107.16 73.3648 107.176 77.5879Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M96.2126 71.161C96.9894 70.0897 97.5452 69.9069 97.8172 69.8175C97.909 69.7873 97.9685 69.7678 97.9932 69.7283C99.0616 68.0266 103.638 68.3426 104.868 69.2707C107.668 71.3823 106.978 72.8397 107.295 74.5774C107.459 75.4688 107.147 76.5627 107.075 77.4804C106.986 76.8716 106.483 74.996 106.445 74.7901C106.001 73.7139 104.057 75.0233 103.037 74.9694C100.746 74.8484 99.0307 74.4462 97.8172 72.9965C97.4539 74.2821 96.3393 75.8431 95.647 75.9895L95.5003 77.2913C95.0838 74.9813 94.7541 73.1724 96.2126 71.161Z'
                fill='var(--neutral-1200)'
            />
        </g>
        <path
            d='M115 43.942C115 51.6417 108.732 57.883 101 57.883C96.6159 57.883 92.7022 55.8768 90.1356 52.7353C88.1749 50.3362 87 47.276 87 43.942C87 36.2423 93.2684 30.001 101 30.001C108.732 30.001 115 36.2423 115 43.942Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M115 43.942C115 51.6417 108.732 57.883 101 57.883C96.6159 57.883 92.7022 55.8768 90.1356 52.7353C88.1749 50.3362 87 47.276 87 43.942C87 36.2423 93.2684 30.001 101 30.001C108.732 30.001 115 36.2423 115 43.942Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.12'
        />
        <mask
            id='mask2_4441_155706'
            mask-type='luminance'
            maskUnits='userSpaceOnUse'
            x='87'
            y='30'
            width='28'
            height='28'
        >
            <path
                d='M115 43.941C115 51.6407 108.732 57.8819 101 57.8819C96.6159 57.8819 92.7022 55.8757 90.1356 52.7343C88.1749 50.3351 87 47.275 87 43.941C87 36.2413 93.2684 30 101 30C108.732 30 115 36.2413 115 43.941Z'
                fill='white'
            />
        </mask>
        <g mask='url(#mask2_4441_155706)'>
            <path
                d='M108.286 52.6015L107.739 41.6589C107.506 37.0108 104.56 33.3966 101.002 33.3966C97.4454 33.3966 94.4988 37.0108 94.2664 41.6589L93.7188 52.6015H108.286Z'
                fill='var(--neutral-1200)'
            />
            <path
                d='M111.559 52.9532C111.041 51.159 109.59 49.7866 107.77 49.3672L103.92 48.4804H98.083L94.233 49.3672C92.4123 49.7866 90.9622 51.159 90.4435 52.9532L88.9744 60.7126H113.028L111.559 52.9532Z'
                fill='var(--center-channel-bg)'
            />
            <path
                opacity='0.24'
                d='M111.559 52.9532C111.041 51.159 109.59 49.7866 107.77 49.3672L103.92 48.4804H98.083L94.233 49.3672C92.4123 49.7866 90.9622 51.159 90.4435 52.9532L88.9744 60.7126H113.028L111.559 52.9532Z'
                fill='#1C58D9'
            />
            <path
                d='M103.531 48.6403L102.741 45.9391H99.2756L98.6347 48.6403C100.034 49.3906 102.132 49.3906 103.531 48.6403Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M103.531 48.6403L102.741 45.9391H99.2756L98.6347 48.6403C100.034 49.3906 102.132 49.3906 103.531 48.6403Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M105.956 40.3675C106.442 40.2298 106.464 40.989 106.28 41.7766C106.111 42.4944 105.956 43.6672 105.45 43.3825C104.841 45.0725 103.73 46.3575 102.386 46.8663C101.969 47.0577 101.526 47.1624 101.066 47.1624C100.474 47.1624 99.9092 46.9888 99.3924 46.6802C98.232 46.08 97.2824 44.885 96.7384 43.3643C96.2394 43.4953 96.0277 42.2555 95.9154 41.7766C95.7727 41.1682 95.5915 40.3674 96.2394 40.3674C96.2527 36.6812 98.4227 33.6986 101.098 33.6986C103.772 33.6986 105.942 36.6812 105.956 40.3675Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M105.956 40.3675C106.442 40.2298 106.464 40.989 106.28 41.7766C106.111 42.4944 105.956 43.6672 105.45 43.3825C104.841 45.0725 103.73 46.3575 102.386 46.8663C101.969 47.0577 101.526 47.1624 101.066 47.1624C100.474 47.1624 99.9092 46.9888 99.3924 46.6802C98.232 46.08 97.2824 44.885 96.7384 43.3643C96.2394 43.4953 96.0277 42.2555 95.9154 41.7766C95.7727 41.1682 95.5915 40.3674 96.2394 40.3674C96.2527 36.6812 98.4227 33.6986 101.098 33.6986C103.772 33.6986 105.942 36.6812 105.956 40.3675Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M106.351 40.3897C106.344 40.4455 106.307 40.4948 106.25 40.5227C106.194 40.5506 106.125 40.5538 106.066 40.5307C104.576 39.9629 103.131 38.4316 102.675 36.9943C101.229 38.4937 98.8432 40.2472 96.4657 40.6326C96.4527 40.635 96.4407 40.6358 96.4278 40.6358L96.4287 40.6366C96.3862 40.6366 96.3436 40.6246 96.3085 40.6031C96.2632 40.5745 96.2336 40.5307 96.2262 40.4829C95.9871 38.7663 96.4912 35.5187 98.0222 34.5167C99.0348 33.8539 99.8141 33.4136 101.082 33.4967C102.37 33.5811 103.77 34.2791 104.768 34.986C106.247 36.0345 106.559 38.7152 106.351 40.3897Z'
                fill='var(--neutral-1200)'
            />
        </g>
        <path
            d='M152 80.9408C152 88.6405 145.731 94.8817 138 94.8817C133.616 94.8817 129.702 92.8755 127.136 89.7341C125.175 87.3349 124 84.2748 124 80.9408C124 73.2412 130.268 67 138 67C145.731 67 152 73.2412 152 80.9408Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M152 80.9408C152 88.6405 145.731 94.8817 138 94.8817C133.616 94.8817 129.702 92.8755 127.136 89.7341C125.175 87.3349 124 84.2748 124 80.9408C124 73.2412 130.268 67 138 67C145.731 67 152 73.2412 152 80.9408Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.12'
        />
        <mask
            id='mask3_4441_155706'
            mask-type='luminance'
            maskUnits='userSpaceOnUse'
            x='124'
            y='67'
            width='29'
            height='28'
        >
            <path
                d='M152 80.9408C152 88.6405 145.732 94.8817 138 94.8817C133.616 94.8817 129.703 92.8755 127.136 89.7341C125.175 87.3349 124 84.2748 124 80.9408C124 73.2412 130.269 67 138 67C145.732 67 152 73.2412 152 80.9408Z'
                fill='white'
            />
        </mask>
        <g mask='url(#mask3_4441_155706)'>
            <path
                d='M150.352 92.3824C149.744 90.417 148.047 88.9139 145.918 88.4545L141.414 87.4836H134.586L130.081 88.4545C127.951 88.9139 126.255 90.417 125.648 92.3824L123.929 100.881H152.07L150.352 92.3824Z'
                fill='var(--center-channel-bg)'
            />
            <path
                opacity='0.24'
                d='M150.352 92.3824C149.744 90.417 148.048 88.9139 145.919 88.4545L141.415 87.4836H134.586L130.082 88.4545C127.952 88.9139 126.255 90.417 125.649 92.3824L123.93 100.881H152.071L150.352 92.3824Z'
                fill='#1C58D9'
            />
            <path
                d='M140.736 87.8616L139.814 85.1019H135.768L135.019 87.8616C136.653 88.6282 139.103 88.6282 140.736 87.8616Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M140.736 87.8616L139.814 85.1019H135.768L135.019 87.8616C136.653 88.6282 139.103 88.6282 140.736 87.8616Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M143.13 79.5591C143.654 79.4178 143.678 80.1968 143.479 81.0049C143.298 81.7414 143.13 82.9448 142.585 82.6527C141.929 84.3868 140.731 85.7053 139.283 86.2273C138.833 86.4237 138.355 86.5312 137.86 86.5312C137.222 86.5312 136.613 86.3531 136.056 86.0364C134.806 85.4206 133.782 84.1944 133.196 82.634C132.658 82.7685 132.43 81.4963 132.309 81.0049C132.155 80.3806 131.96 79.559 132.658 79.559C132.672 75.7767 135.011 72.7163 137.894 72.7163C140.777 72.7163 143.116 75.7767 143.13 79.5591Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M143.13 79.5591C143.654 79.4178 143.678 80.1968 143.479 81.0049C143.298 81.7414 143.13 82.9448 142.585 82.6527C141.929 84.3868 140.731 85.7053 139.283 86.2273C138.833 86.4237 138.355 86.5312 137.86 86.5312C137.222 86.5312 136.613 86.3531 136.056 86.0364C134.806 85.4206 133.782 84.1944 133.196 82.634C132.658 82.7685 132.43 81.4963 132.309 81.0049C132.155 80.3806 131.96 79.559 132.658 79.559C132.672 75.7767 135.011 72.7163 137.894 72.7163C140.777 72.7163 143.116 75.7767 143.13 79.5591Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.56'
            />
            <path
                d='M132.172 72.0366C130.832 73.675 130.803 76.3499 132.096 78.7459C132.538 79.277 132.978 79.8071 133.42 80.3382C133.406 76.4669 134.034 75.424 134.644 75.234C135.649 74.9186 136.841 76.8499 139.022 76.8017C139.354 76.7942 140.099 76.7673 140.554 76.2459C140.946 75.7963 140.887 75.2448 141.005 75.233C141.2 75.2137 141.552 76.2673 142.229 80.3371C142.664 79.8028 143.101 79.2674 143.536 78.733C143.774 77.8038 143.993 76.5849 144.008 75.1493C144.028 73.2083 143.077 71.9796 142.737 70.8884C141.457 74.1194 140.167 70.0895 136.056 70.0961C134.72 70.0983 133.05 70.9636 132.172 72.0366Z'
                fill='var(--neutral-1200)'
            />
        </g>
        <rect
            x='108'
            y='4'
            width='83'
            height='50'
            rx='4'
            fill='var(--neutral-1200)'
            fillOpacity='0.32'
        />
        <rect
            x='110.5'
            y='0.5'
            width='82'
            height='49'
            rx='3.5'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
        />
        <path
            d='M152 10H166.481'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M152 16H175'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M152 22H182'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M152 28H182'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M168.891 10H178.525'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            d='M180.932 10H183.946'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.56'
            strokeLinecap='round'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M127.509 6.91797H130.5L130.879 9.3795C131.794 9.58757 132.651 9.94891 133.422 10.4351L135.435 8.95885L137.55 11.0739L136.056 13.1106C136.521 13.8733 136.865 14.7179 137.061 15.6177L139.592 16.007V18.9982L136.996 19.3976C136.779 20.2497 136.428 21.0485 135.968 21.7704L137.55 23.9276L135.435 26.0426L133.226 24.4233C132.521 24.8414 131.747 25.1567 130.926 25.3485L130.505 28.0859H127.514L127.089 25.3257C126.282 25.127 125.522 24.8087 124.829 24.3908L122.577 26.0425L120.462 23.9274L122.097 21.6981C121.661 20.9993 121.328 20.2302 121.118 19.4116L118.422 18.9969V16.0057L121.053 15.601C121.243 14.7356 121.57 13.9214 122.01 13.1824L120.464 11.0737L122.579 8.95866L124.637 10.4677C125.391 9.98385 126.23 9.62025 127.127 9.40401L127.509 6.91797ZM133.041 17.3689C133.041 19.5704 131.256 21.355 129.054 21.355C126.853 21.355 125.068 19.5704 125.068 17.3689C125.068 15.1675 126.853 13.3828 129.054 13.3828C131.256 13.3828 133.041 15.1675 133.041 17.3689Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M138.405 30.9492H140.038L140.244 32.2907C140.745 32.4044 141.213 32.602 141.635 32.8679L142.73 32.0643L143.885 33.2188L143.071 34.3279C143.325 34.744 143.513 35.2048 143.619 35.6957L145 35.9081V37.5407L143.584 37.7585C143.465 38.2245 143.274 38.6613 143.022 39.0558L143.885 40.2329L142.73 41.3874L141.525 40.5032C141.14 40.7307 140.719 40.9023 140.272 41.0069L140.042 42.5039H138.409L138.177 40.9948C137.737 40.8867 137.324 40.7135 136.946 40.4861L135.715 41.3888L134.561 40.2344L135.453 39.0171C135.215 38.6355 135.033 38.2155 134.918 37.7683L133.445 37.5418V35.9092L134.881 35.6882C134.985 35.2163 135.163 34.7723 135.403 34.3692L134.56 33.2202L135.715 32.0657L136.835 32.887C137.247 32.6218 137.706 32.4226 138.197 32.3043L138.405 30.9492ZM141.426 36.6523C141.426 37.8539 140.452 38.828 139.25 38.828C138.048 38.828 137.074 37.8539 137.074 36.6523C137.074 35.4507 138.048 34.4766 139.25 34.4766C140.452 34.4766 141.426 35.4507 141.426 36.6523Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
    </svg>
);

export default SystemRolesSVG;
